import { render, staticRenderFns } from "./CookiePolicyModal.vue?vue&type=template&id=9bff07d2&scoped=true&"
import script from "./CookiePolicyModal.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicyModal.vue?vue&type=style&index=0&id=9bff07d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bff07d2",
  null
  
)

export default component.exports